import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const checkAuth = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/auth/me`);
            setUser(response.data.user);
            setError(null);
        } catch (err) {
            // Only logout if it's a 401 Unauthorized. 
            // 429 Too Many Requests or 500 should NOT log the user out.
            if (err.response && err.response.status === 401) {
                setUser(null);
            }
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    const login = async (email, password) => {
        const response = await axios.post(`${API_BASE_URL}/api/auth/login`, { email, password });
        await checkAuth(); // Refresh user state
        return response;
    };

    const logout = async () => {
        try {
            await axios.post(`${API_BASE_URL}/api/auth/logout`);
        } catch (err) {
            console.error('Logout error:', err);
        }
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, error, login, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
